import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppraisalService } from "../services/appraisal.service";
import { LoginService } from "../services/login.service";

@Component({
  selector: "app-view-print",
  templateUrl: "./view-print.component.html",
  styleUrls: ["./view-print.component.css"],
})
export class ViewPrintComponent implements OnInit {
  roll_id;
  form_id;
  level;
  formData = {
    form_id: "",
  };
  userData = {};
  showCommentsVisibility = false;

  constructor(
    private apprais: AppraisalService,
    private router: Router,
    private route: ActivatedRoute,
    public ls: LoginService
  ) {}

  ngOnInit() {
    var today = new Date();
    this.form_id = this.route.snapshot.params.form_id;
    this.level = this.route.snapshot.params.level;

    this.formData.form_id = this.form_id;
    var user = this.apprais.getFormInfo(this.formData).subscribe((res) => {
      //console.log(res);
      this.userData = res.form_info;
      this.showCommentsVisibility = res.form_visibility.visibility;

      this.userData["l4_entry_date"] = this.dateFun(today);
      this.roll_id = this.ls.role;

      // console.log(this.userData);
    });
  }
  toHTML(input): any {
    return new DOMParser().parseFromString(input, "text/html").documentElement
      .textContent;
  }
  dateFun(dateStr) {
    var dateObj = new Date(dateStr);
    var month = dateObj.getMonth() + 1; //months from 1-12
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();

    var newdate = year + "-" + month + "-" + day;
    //var newdate = day + "/" + month + "/" + year;
    //console.log(newdate);
    return newdate;
  }
  printerDiv() {
    var divElements = document.getElementById("printArea").innerHTML;

    //Get the HTML of whole page
    var oldPage = document.body.innerHTML;

    //Reset the pages HTML with divs HTML only

    document.body.innerHTML =
      "<html><head><title></title></head><body>" + divElements + "</body>";

    //Print Page
    window.print();

    //Restore orignal HTML
    // document.body.innerHTML = oldPage;
    window.location.href = "viewPrintForm/" + this.form_id + "/" + this.level;
  }

  fullPerformance(form_type, l2_performance_rating) {
    var remarks = "";
    var l2_grading =
      typeof l2_performance_rating === "number" ? l2_performance_rating : 0;
    if (form_type == 1) {
      if (l2_grading == 30) {
        remarks = "Outstanding";
      } else if (l2_grading == 24) {
        remarks = "Very Good";
      } else if (l2_grading == 18) {
        remarks = "Good";
      } else if (l2_grading == 12) {
        remarks = "Average";
      } else {
        remarks = "Unsatisfactory";
      }
    } else {
      if (l2_grading == 40) {
        remarks = "Outstanding";
      } else if (l2_grading == 32) {
        remarks = "Very Good";
      } else if (l2_grading == 24) {
        remarks = "Good";
      } else if (l2_grading == 16) {
        remarks = "Average";
      } else {
        remarks = "Unsatisfactory";
      }
    }
    return remarks;
  }

  fullAllRating(l2_performance_rating) {
    var remarks = "";
    var l2_grading =
      typeof l2_performance_rating === "number" ? l2_performance_rating : 0;
    if (l2_grading == 10) {
      remarks = "Outstanding";
    } else if (l2_grading == 8) {
      remarks = "Very Good";
    } else if (l2_grading == 6) {
      remarks = "Good";
    } else if (l2_grading == 4) {
      remarks = "Average";
    } else {
      remarks = "Unsatisfactory";
    }
    return remarks;
  }
}



// WEBPACK FOOTER //
// ./src/app/view-print/view-print.component.ts